<!--
 * @Descripttion: 
 * @Author: juanjuanhui
 * @Date: 2022-03-07 20:04:33
 * @LastEditors: juanjuanhui
 * @LastEditTime: 2022-05-19 15:19:11
-->
<template>
  <router-view />
</template>

<script>
export default {
  name: "VillageManagement",
};
</script>
